<template lang="html">
  <d-form @submit.prevent="save">
    <d-form-row>
      <d-col class="form-group">
        <label for="name">Título</label>
        <d-form-input
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.title"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col class="form-group">
        <label for="Types">Tipo do chamado</label>
        <d-select
          size="sm"
          v-model="model.type_id"
          :options="types"
          value-field="id"
          text-field="name"
          @change="setType"
        ></d-select>
        <d-form-invalid-feedback>Tipo do chamado é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row v-if="isNotCustomer">
      <d-col class="form-group">
        <label for="User">Cliente</label>
        <autocomplete
          ref="autocomplete"
          placeholder="Usuário"
          :state="hasErrorFiled('user_name')"
          :items="users"
          item-show="name"
          :on-input="onInput"
          :on-select="setUser"
          :on-show-text="showText"
        ></autocomplete>
        <d-form-invalid-feedback>Cliente é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row v-if="projects.length > 1">
      <d-col class="form-group">
        <label for="Project">Obras</label>
        <d-select
          size="sm"
          v-model="model.project_id"
          :options="projects"
          value-field="id"
          text-field="label"
        ></d-select>
        <d-form-invalid-feedback>Obra é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col class="form-group">
        <label for="name">Anexar arquivo</label>
        <upload-files-list :model.sync="model.files"/>
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col cols="12"  class="form-group">
        <editor ref="comment" :model.sync="model.comment" placeholder="Comentário"></editor>
      </d-col>
    </d-form-row>

    <d-form-row class="mt-4">
      <d-col cols="12">
        <d-button size="sm" class="btn-accent ml-auto">
          <i class="material-icons">file_copy</i> Criar
        </d-button>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import TicketService from '_services/rest/modules/ticket';
import UploadFilesList from '_shared/UploadFilesList.vue';
import CustomerService from '_services/rest/modules/customer';
import MixinValidateForm from '_common/mixins/ValidateForm';
import { MODEL } from './TicketModel';

export default {
  name: 'ticket-form',
  mixins: [MixinValidateForm],
  components: {
    Editor,
    Autocomplete,
    CustomerService,
    UploadFilesList,
  },
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  data() {
    return {
      searchTimeoutId: null,
      types: [],
      projects: [],
      errors: {
        type_id: { required: false },
        user_name: { required: false },
      },
    };
  },
  computed: {
    users() {
      const { customerUserList } = this.$store.state.user;
      if (customerUserList && customerUserList.length) {
        return customerUserList;
      }
      return [];
    },
    isNotCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) { // User type id : Customer
        return false;
      }
      return true;
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'getCustomerUserList',
    ]),
    choseFile(event) {
      const { files } = event.target;
      this.model.files = Array.from(files);
    },
    getTypes() {
      TicketService.getTypes()
        .then(response => {
          this.types = response;
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    searchUserList(name = '') {
      const params = {
        type_id: 3, // User type id: Customer
        search: name,
      };
      this.getCustomerUserList(params);
    },
    getProjects() {
      CustomerService.getProjectByCutomerId(this.model.customer_id)
        .then(response => {
          this.projects = response;
          if (this.projects.length > 0) {
            this.model.project_id = this.projects[0].id;
          }
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    setType(event) {
      this.model.type = this.types.find(type => type.id === event);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.searchUserList(name);
      }, 500);
    },
    save() {
      if (this.checkForm()) {
        TicketService.saveTicket(this.model)
          .then(response => {
            this.activeAlert({ message: 'Chamado salvo com sucesso', theme: 'success' });
            this.$router.push(`/admin/chamados/${response.data.id}`);
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
    },
    setUser(user) {
      this.model.user_id = user.id;
      this.model.customer_id = user.settings.customer_id;
      this.model.user_name = user.name;
      this.getProjects();
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.email}</strong>`;
    },
  },
  mounted() {
    if (!this.isNotCustomer) {
      const { user } = this.$store.state.user;
      this.model.customer_id = user.settings.customer_id;
      this.model.user_id = user.id;
      this.getProjects();
    }
    this.getTypes();
  },
};
</script>

<style lang="scss" scoped>
</style>
